import axios from "../utils/api-client";

const API_BASE_URL = `${process.env.REACT_APP_API_END_POINT}`;

// Types
export interface Product {
    id: number;
    itemNumber: string;
    name: string;
    categoryId?: number;
    categoryName?: string;
    description?: string;
    isActive: boolean;
    companyId?: number | null;
    createdDate: string;
    modifiedDate?: string;
}

export interface Category {
    id: number;
    name: string;
    description?: string;
    sortOrder: number;
    isActive: boolean;
    productCount: number;
}

export interface CreateProductDto {
    itemNumber: string;
    name: string;
    categoryId?: number;
    description?: string;
    isActive?: boolean;
}

export interface UpdateProductDto {
    itemNumber?: string;
    name?: string;
    categoryId?: number;
    description?: string;
    isActive?: boolean;
}

export interface CreateCategoryDto {
    name: string;
    description?: string;
    sortOrder?: number;
}

export interface UpdateCategoryDto {
    name?: string;
    description?: string;
    sortOrder?: number;
    isActive?: boolean;
}

// Product API calls
export const productsApi = {
    // Get all products
    getAll: async (includeInactive = false): Promise<Product[]> => {
        const response = await axios.get(
            `${API_BASE_URL}/Products?includeInactive=${includeInactive}`
        );
        return response.data;
    },

    // Get a single product
    getById: async (id: number): Promise<Product> => {
        const response = await axios.get(
            `${API_BASE_URL}/Products/${id}`
        );
        return response.data;
    },

    // Create a new product
    create: async (product: CreateProductDto): Promise<Product> => {
        const response = await axios.post(
            `${API_BASE_URL}/Products`,
            product
        );
        return response.data;
    },

    // Update a product
    update: async (id: number, product: UpdateProductDto): Promise<Product> => {
        const response = await axios.put(
            `${API_BASE_URL}/Products/${id}`,
            product
        );
        return response.data;
    },

    // Delete a product (soft delete by default)
    delete: async (id: number, hardDelete = false): Promise<void> => {
        await axios.delete(
            `${API_BASE_URL}/Products/${id}?hardDelete=${hardDelete}`
        );
    },
};

// Category API calls
export const categoriesApi = {
    // Get all categories
    getAll: async (includeInactive = false): Promise<Category[]> => {
        const response = await axios.get(
            `${API_BASE_URL}/Products/categories?includeInactive=${includeInactive}`
        );
        return response.data;
    },

    // Create a new category
    create: async (category: CreateCategoryDto): Promise<Category> => {
        const response = await axios.post(
            `${API_BASE_URL}/Products/categories`,
            category
        );
        return response.data;
    },

    // Update a category
    update: async (id: number, category: UpdateCategoryDto): Promise<Category> => {
        const response = await axios.put(
            `${API_BASE_URL}/Products/categories/${id}`,
            category
        );
        return response.data;
    },

    // Delete a category
    delete: async (id: number, hardDelete = false): Promise<void> => {
        await axios.delete(
            `${API_BASE_URL}/Products/categories/${id}?hardDelete=${hardDelete}`
        );
    },
};

